export default "__VITE_ASSET__B_x$2MGO__"